import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';

export const useUsersTableColumns = () => {
  const { t } = useTranslation();

  const usersColumns: SelectableTableColumn[] = [
    {
      id: 'userId',
      type: 'checkbox',
      title: '',
      filterType: null,
    },
    {
      id: 'firstName',
      type: 'text',
      title: t('users:table.firstName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'lastName',
      type: 'text',
      title: t('users:table.lastName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'email',
      type: 'text',
      title: t('users:table.email'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'pesel',
      type: 'text',
      title: t('users:table.pesel'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'accountTypeName',
      type: 'text',
      title: t('users:table.accountTypeName'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'examCommittee',
      type: 'text',
      title: t('users:table.examCommittee'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'phone',
      type: 'text',
      title: t('users:table.phone'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'accountStatus',
      type: 'text',
      title: t('users:table.accountStatus'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  const examinersColumns: SelectableTableColumn[] = [
    {
      id: 'userId',
      type: 'checkbox',
      title: '',
      filterType: null,
    },
    {
      id: 'firstName',
      type: 'text',
      title: t('examiners:table.firstName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'lastName',
      type: 'text',
      title: t('examiners:table.lastName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'email',
      type: 'text',
      title: t('examiners:table.email'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'pesel',
      type: 'text',
      title: t('examiners:table.pesel'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examCommittee',
      type: 'text',
      title: t('examiners:table.examCommittee'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'phone',
      type: 'text',
      title: t('examiners:table.phone'),
      filterType: 'search',
      sortable: true,
    },

    {
      id: 'status',
      type: 'text',
      title: t('examiners:table.accountStatus'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];

  return {
    usersColumns,
    examinersColumns,
  };
};
